import UptimeBob from "@/assets/images/uptime-bob.svg";
import {OnboardingWizardStep} from "@/lib/types/accounts.ts";

import {StepContent} from "../step/Step";
import {StepAlertsBody} from "./StepAlertsBody";

export const STEP_ALERTS: StepContent = {
  name: OnboardingWizardStep.ALERTS,
  title: "Get Alerts.",
  subtitle: "Where can we reach you with an Alert?",
  infotext: (
    <div>
      For alerts only.
      <br />
      We won’t ever call you at this number.
    </div>
  ),
  body: StepAlertsBody,
};

export const STEP_ALERTS_WELCOME: StepContent = {
  ...STEP_ALERTS,
  title: "Welcome to Uptime, %name%",
  subtitle: "Let's get you set up. Where can we reach you with an Alert?",
  iconURL: UptimeBob,
  iconPosition: "top",
};
